import React from 'react';
import { compose, connect } from 'react-redux';

import DonloadAlert from '../components/downloadAlert/downloadAlert.jsx';
import { setConfig } from '../reducers/downloadAlert.js';
import { setQuestion } from '../reducers/targets.js';


class DonwloadComponent extends React.Component {
    constructor(props) {
        super()
        this.handleCloseAlert = this.handleCloseAlert.bind(this)
        this.handleEnter = this.handleEnter.bind(this)
        this.handleLeave = this.handleLeave.bind(this)
        this.setTime = this.setTime.bind(this)
        this.clearTime = this.clearTime.bind(this)
        this.handleCallbackOk = this.handleCallbackOk.bind(this)
    }

    componentDidMount() {
        this.times = this.props.downloadConfig.duration || 0
        this.props.downloadConfig.duration && this.setTime(this.times)
    }

    shouldComponentUpdate(state, props) {
        console.log(state, props)
        return true
    }
    //检测到prop值有更新duration则设置定时器
    componentDidUpdate() {
        this.clearTime()
        this.props.downloadConfig.duration && (this.times = this.props.downloadConfig.duration, this.setTime(this.times))
    }

    //点击关闭X按钮触发
    handleCloseAlert() {
        this.clearTime()
        downloadAlert({ show: false })
    }
    //鼠标进入窗口时
    handleEnter() {
        this.clearTime()
    }
    //清除定时器
    clearTime() {
        clearTimeout(this.time)
        clearInterval(this.time1)
    }
    //鼠标离开窗口时
    handleLeave() {
        this.props.downloadConfig.duration && this.setTime(this.times)
    }
    //设置定时器，关闭窗口
    setTime(num) {
        //这里是实现鼠标移入时，实现暂停定时器效果
        this.time1 = setInterval(() => {
            this.times -= 100
        }, 100)
        this.time = setTimeout(() => {
            console.log('s')
            this.handleCloseAlert()
        }, num)
    }

    //执行确认按钮
    handleCallbackOk() {
        this.props.downloadConfig.clickOk && this.props.downloadConfig.clickOk()
        this.handleCloseAlert()
    }
    render() {
        return <DonloadAlert
            closeAlert={this.handleCloseAlert}
            downloadConfig={this.props.downloadConfig}
            intl={this.props.intl}
            Enter={this.handleEnter}
            Leave={this.handleLeave}
            clickOk={this.handleCallbackOk}
            {...this.props}
        />
    }
}

const mapStateToProps = (state) => {
    return {
        downloadConfig: state.scratchGui.downloadAlert.donwloadConfig
    }
}
const mapDispatchToProps = (dispatch, props) => ({
    setQuestion: (arg) => {
        dispatch(setQuestion(arg))
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DonwloadComponent)